<template>
  <div class="flex items-center gap-2">
    <template v-if="props.showFieldData">
      <RfSelect
        :modelValue="fieldDataPair0"
        :items="fieldData"
        itemKey="var"
        itemValue="label"
        class="min-w-px flex-1 grow"
        autoWidth
        variant="outlined"
        mandatory
        placeholder="Select Field Data variable"
        @update:modelValue="v => emit('update:fieldDataPair0', v)"
      />
      <RfSelect
        v-if="isDropdown"
        :multiple="isMultiple"
        :modelValue="fieldDataPair1"
        :items="fieldDataValues?.values || []"
        class="mr-2 min-w-px flex-1 grow"
        autoWidth
        variant="outlined"
        mandatory
        :placeholder="`Select ${fieldDataValues?.label || ''}`"
        @update:modelValue="v => emit('update:fieldDataPair1', v)"
      />
      <RfInput
        v-else
        :modelValue="fieldDataPair1"
        variant="outlined"
        class="mr-2 min-w-px flex-1 grow"
        autoWidth
        placeholder="Value"
        :errorMessage="error ? errorValue.msg : ''"
        @update:modelValue="v => emit('update:fieldDataPair1', v)"
      />
      <RfButtonNew
        v-if="fieldDataValues.tooltip"
        :tooltipMessage="fieldDataValues.tooltip"
        type="table"
        class="grow-0"
      >
        <RfHelpIcon class="h-6 w-6" />
      </RfButtonNew>
    </template>
    <template v-else>
      <RfInput
        :modelValue="fieldDataPair0"
        variant="outlined"
        autoWidth
        class="flex-1 grow"
        placeholder="Key"
        @update:modelValue="v => emit('update:fieldDataPair0', v)"
      />
      <RfInput
        :modelValue="fieldDataPair1"
        variant="outlined"
        autoWidth
        class="flex-1 grow"
        placeholder="Value"
        @update:modelValue="v => emit('update:fieldDataPair1', v)"
      />
    </template>
    <RfButtonNew type="table" class="grow-0" @click="$emit('delete')">
      <RfDeleteIcon class="fill-vermillion-50 h-6 w-6" />
    </RfButtonNew>
  </div>
</template>

<script setup>
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfDeleteIcon from "@/components/icons/RfDeleteIcon.vue";
import RfHelpIcon from "@/components/icons/RfHelpIcon.vue";
import RfInput from "@/components/inputs/RfInput.vue";
import RfSelect from "@/components/inputs/RfSelect.vue";
import { computed, watch } from "vue";

const emit = defineEmits(["delete", "update:fieldDataPair0", "update:fieldDataPair1"]);
const props = defineProps({
  showFieldData: { type: Boolean, default: false },
  fieldData: { type: Array, default: () => [] },
  fieldDataValues: { type: Object, default: () => ({}) },
  fieldDataPair0: { type: String, default: "" },
  fieldDataPair1: { type: String, default: "" },
});

const isDropdown = computed(() => props.fieldDataValues?.type === "dropdown");
const isMultiple = computed(() => props.fieldDataValues?.multiple);

const rules = computed(() => {
  if (!props.fieldDataValues?.regexp) return [];
  if (typeof props.fieldDataValues.regexp === "string") return [props.fieldDataValues.regexp];
  return [];
});

const defaultValue = { bool: false, msg: "" };

const errorValue = computed(
  () =>
    rules.value.map(r => {
      const regexp = !!(props.fieldDataPair1 || "").match(new RegExp(r));
      if (regexp) return defaultValue;
      return { bool: true, msg: `Input does not satisfy ${r}` };
    })?.[0] || defaultValue,
);

const error = computed(() => !isDropdown.value && !!errorValue.value.bool);

watch(
  () => props.showFieldData && props.fieldDataPair0,
  () => emit("update:fieldDataPair1", null),
);

defineExpose({ error });
</script>
